<template>
  <div class="register">
    <!-- 登录弹出框 -->
    <el-dialog
      class="loginDialogBox"
      :visible.sync="loginDialogVisible"
      :before-close="handleLoginDialogClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <span slot="title">
        <div class="site_name">{{ siteName }}</div>
      </span>
      <el-form :model="loginForm" :rules="rules" ref="loginForm">
        <el-row class="loginDialogBoxTitle"
          ><i class="el-icon-user-solid">登录</i></el-row
        >
        <el-form-item prop="user_name" class="loginFormItem">
          <el-input
            placeholder="请输入注册邮箱或者手机号"
            v-model="loginForm.user_name"
          >
            <template slot="prepend"
              >邮箱<span style="margin: 0 8px">/</span
              ><span
                >手机
                <el-tooltip content="国际/港澳台手机号需要以国家(或地区)码开头，如香港手机号以+852开头" placement="top-start" effect="light"><i class="el-icon-question"></i></el-tooltip> </span
            ></template>
            <!-- <template slot="prepend">
              <el-select style="width: 116px" v-model="loginForm.country_name">
                <el-option
                  v-for="item in countryCodes"
                  :key="item.name"
                  :label="`${item.name}(${item.code})`"
                  :value="item.name"
                ></el-option>
              </el-select>
            </template> -->
          </el-input>
        </el-form-item>
        <el-form-item prop="login_pwd" class="loginFormItem">
          <el-input
            placeholder="请输入密码"
            v-model="loginForm.login_pwd"
            type="password"
          >
            <template slot="prepend"
              >密<span style="margin-left: 2em" />码<i class="el-icon-lock"
            /></template>
          </el-input>
        </el-form-item>
        <div class="loginFormItem inlineFlex">
          <el-input
            placeholder="输入验证码"
            v-model="loginForm.captcha_code"
            autocomplete="off"
            autocapitalize="off"
            spellcheck="false"
            maxlength="4"
          >
            <template slot="prepend"
              >验<span style="margin-left: 0.5em" />证<span
                style="margin-left: 0.5em" />码<i class="el-icon-lock"
            /></template>
          </el-input>
          <div class="captcha_code" v-if="loginForm.showCaptchaBtn === 0">
            <img :src="loginForm.captcha_url" ref="code" @click="changeCode" />
            <span style="font-size: 12px">看不清？点图刷新</span>
          </div>
          <el-button
            v-if="loginForm.showCaptchaBtn === 1"
            style="margin-left: 10px; padding: 12px"
            @click="toGetCaptchaCode"
            >获取验证码</el-button
          >
        </div>
      </el-form>
      <el-alert
        :style="{ display: loginMessageVisible }"
        :title="loginMessage"
        type="error"
        @close="loginMessageClose"
      >
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="loading"
          type="primary"
          style="width: 100%"
          @click="handleLogin"
          >登 录</el-button
        >
        <div class="textBtnRow">
          <el-link @click="toResetPassword">忘记密码?</el-link>
          <el-link type="primary" @click="toRegisterDialogBox"
            >新用户注册</el-link
          >
        </div>
      </span>
    </el-dialog>
    <!-- 注册弹出框 -->
    <el-dialog
      class="registerDialogBox"
      :visible.sync="registerDialogVisible"
      :before-close="handleRegisterDialogClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <span slot="title">
        <div class="site_name">{{ siteName }}</div>
      </span>
      <template v-if="!extraInfoFormVisible">
        <el-form :model="registerForm" :rules="rules" ref="registerForm">
          <el-row class="loginDialogBoxTitle"
            ><i class="el-icon-user-solid"
              >新用户注册（填写登录信息）</i
            ></el-row
          >
          <el-form-item class="loginFormItem" prop="reg_email">
            <el-input
              placeholder="注册邮箱可用来登录系统"
              v-model="registerForm.reg_email"
              auto-complete="off"
            >
              <template slot="prepend"
                >邮<span style="margin-left: 2em" />箱<i
                  class="el-icon-message"
              /></template>
            </el-input>
          </el-form-item>
          <el-form-item class="loginFormItem" prop="login_pwd">
            <el-input
              placeholder="输入密码"
              v-model="registerForm.login_pwd"
              type="password"
              auto-complete="new-password"
            >
              <template slot="prepend"
                >密<span style="margin-left: 2em" />码<i class="el-icon-lock"
              /></template>
            </el-input>
          </el-form-item>
          <el-form-item class="loginFormItem" prop="conform_pwd">
            <el-input
              placeholder="再次输入密码"
              v-model="registerForm.conform_pwd"
              type="password"
              auto-complete="off"
            >
              <template slot="prepend"
                >确认密码<i class="el-icon-lock"
              /></template>
            </el-input>
          </el-form-item>
          <div class="loginFormItem inlineFlex">
            <el-input
              placeholder="输入验证码"
              v-model="registerForm.captcha_code"
              autocomplete="off"
              autocapitalize="off"
              spellcheck="false"
              maxlength="4"
            >
              <template slot="prepend"
                >验<span style="margin-left: 0.5em" />证<span
                  style="margin-left: 0.5em" />码<i class="el-icon-lock"
              /></template>
            </el-input>
            <div class="captcha_code" v-if="registerForm.showCaptchaBtn === 0">
              <img
                :src="loginForm.captcha_url"
                ref="code"
                @click="changeCode"
              />
              <span style="font-size: 12px">看不清？点图刷新</span>
            </div>
            <el-button
              v-if="registerForm.showCaptchaBtn === 1"
              style="margin-left: 10px; padding: 12px"
              @click="toGetCaptchaCode"
              >获取验证码</el-button
            >
          </div>
          <div class="loginFormItem inlineFlex" prop="captcha_code">
            <el-input
              placeholder="输入认证码"
              v-model="registerForm.verify_code"
              autocomplete="off"
              autocapitalize="off"
              spellcheck="false"
              maxlength="4"
            >
              <template slot="prepend"
                >认<span style="margin-left: 0.5em" />证<span
                  style="margin-left: 0.5em" />码<i class="el-icon-lock"
              /></template>
            </el-input>
            <el-button
              style="margin-left: 10px; padding: 12px"
              :disabled="sendMsgDisabled"
              @click="sendRegCapthaCode()"
            >
              <span v-if="!sendMsgDisabled">获取认证码</span>
              <span v-if="sendMsgDisabled">{{ codeTime1 + '秒后获取' }}</span>
            </el-button>
          </div>
        </el-form>
        <el-alert
          :style="{ display: registerMessageVisible }"
          :title="registerMessage"
          type="error"
          @close="registerMessageClose"
        >
        </el-alert>
        <span slot="footer" class="dialog-footer">
          <el-button
            :loading="loading"
            type="primary"
            style="width: 100%"
            @click="handleRegister"
            >下一步</el-button
          >
          <div class="textBtnRow">
            <el-link type="primary" @click="toLoginDialogBox"
              >已有帐号? 前往登录</el-link
            >
          </div>
        </span>
      </template>

      <template v-else>
        <el-form
          :model="extraInfoForm"
          :rules="extraInfoRules"
          ref="extraInfoForm"
        >
          <el-row class="loginDialogBoxTitle"
            ><i class="el-icon-user-solid"
              >填写个人基本信息，完成注册</i
            ></el-row
          >
          <el-form-item class="loginFormItem" prop="last_name_zh">
            <el-input
              placeholder="输入姓"
              v-model="extraInfoForm.last_name_zh"
              type="text"
            >
              <template slot="prepend"
                ><span style="margin-right: 15px">本人姓</span></template
              >
            </el-input>
          </el-form-item>
          <el-form-item class="loginFormItem" prop="first_name_zh">
            <el-input
              placeholder="输入名"
              v-model="extraInfoForm.first_name_zh"
            >
              <template slot="prepend"
                ><span style="margin-right: 15px">本人名</span></template
              >
            </el-input>
          </el-form-item>
          <el-form-item class="loginFormItem" prop="organization">
            <el-input
              placeholder="输入单位"
              v-model="extraInfoForm.organization"
            >
              <template slot="prepend">工作单位</template>
            </el-input>
          </el-form-item>

          <el-form-item class="loginFormItem" prop="phone">
            <el-input placeholder="请输入手机号" v-model="extraInfoForm.phone">
              <!-- <template slot="prepend"
                >手<span style="margin-left: 26px">机</span></template
              > -->
              <template slot="prepend">
                <el-select v-model="extraInfoForm.country_name">
                  <el-option
                    v-for="item in countryCodes"
                    :key="item.name"
                    :label="`${item.name}(${item.code})`"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </template>
            </el-input>
          </el-form-item>

          <div class="loginFormItem inlineFlex" prop="phone_verify_code">
            <el-input
              placeholder="请输入手机认证码"
              v-model="extraInfoForm.phone_verify_code"
              autocomplete="off"
              autocapitalize="off"
              spellcheck="false"
              maxlength="4"
            >
              <template slot="prepend"
                ><span style="margin-right: 15px">认证码</span></template
              >
            </el-input>
            <el-button
              style="margin-left: 10px; padding: 12px"
              :disabled="sendMsgDisabled"
              @click="sendPhoneRegCapthaCode()"
            >
              <span v-if="!sendMsgDisabled">获取</span>
              <span v-if="sendMsgDisabled">{{ codeTime2 + '秒后获取' }}</span>
            </el-button>
          </div>
        </el-form>
        <el-alert
          :style="{ display: registerMessageVisible }"
          :title="registerMessage"
          type="error"
          @close="registerMessageClose"
        >
        </el-alert>
        <span slot="footer" class="dialog-footer">
          <el-button
            :loading="loading"
            type="primary"
            style="width: 100%"
            @click="handleRegister"
            >注册</el-button
          >
          <div class="textBtnRow">
            <el-link type="primary" @click="toLoginDialogBox"
              >已有帐号? 前往登录</el-link
            >
          </div>
        </span>
      </template>
    </el-dialog>
    <!-- 注册成功弹出框 -->
    <el-dialog
      class="registerDialogBox"
      :visible.sync="registerSuccessDialogVisible"
      :before-close="handleRegisterSuccessDialogClose"
      :destroy-on-close="true"
    >
      <span slot="title">
        <div class="site_name">{{ siteName }}</div>
      </span>
      <span>注册成功，感谢您的加入！</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="loading"
          type="primary"
          style="width: 100%"
          @click="regSuccesstoLoginDialogBox"
          >登录</el-button
        >
      </span>
    </el-dialog>
    <!-- 登录后如果用户真实姓名没写，提示完善用户信息 -->
    <el-dialog
      width="30%"
      title="提示"
      :close-on-click-modal="false"
      :show-close="true"
      :visible.sync="tipDialog"
    >
      <span>您的个人信息还不完善，请前往用户中心编辑</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleGoUserInfo"
          >现在去完善</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CountrySelector from 'vue-country-selector';

import { getCaptcha } from '@/apis/captcha.js';
import { login } from '@/apis/login.js';
import {
  register,
  checkEmail,
  getRegisterVerifyCode,
  getRegisterPhoneVerifyCode,
} from '@/apis/register.js';

import { countryCodes, getCountryCode } from '@/apis/countryCode';

export default {
  name: 'Register',
  props: {
    siteName: String,
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.registerForm.login_pwd !== '') {
          this.$refs.registerForm.validateField('conform_pwd');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.registerForm.login_pwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      countryCodes: countryCodes,
      codeTime1: 59, // 发送认证码倒计时
      codeTime2: 59, // 发送认证码倒计时
      sendMsgDisabled: false, // 是否显示获取验证码按钮
      rules: {
        reg_email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
        user_name: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
        ],
        login_pwd: [
          {
            validator: validatePass,
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
          { min: 6, message: '密码至少 6 个字符', trigger: 'blur' },
          { max: 20, message: '密码最多 20 个字符', trigger: 'blur' },
        ],
        conform_pwd: [{ validator: validatePass2, trigger: 'blur' }],
        captcha_code: [
          {
            required: true,
            message: '请输入邮箱中收到的验证码',
            trigger: 'blur',
          },
          { min: 4, message: '输入4位验证码', trigger: 'blur' },
          { max: 4, message: '输入4位验证码', trigger: 'blur' },
        ],
      },
      extraInfoRules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        last_name_zh: [
          { required: true, message: '请输入姓', trigger: 'blur' },
        ],
        first_name_zh: [
          { required: true, message: '请输入名', trigger: 'blur' },
        ],
        organization: [
          { required: true, message: '请输入单位', trigger: 'blur' },
        ],
        phone_verify_code: [
          {
            required: true,
            message: '请输入手机收到的验证码',
            trigger: 'blur',
          },
          { min: 4, message: '输入4位验证码', trigger: 'blur' },
          { max: 4, message: '输入4位验证码', trigger: 'blur' },
        ],
      },

      loading: false,
      loginMessage: '',
      registerMessage: '',
      registerSuccessDialogVisible: false,
      loginMessageVisible: 'none',
      registerMessageVisible: 'none',
      loginForm: {
        user_name: '',
        login_pwd: '',
        captcha_code: '',
        captcha_url: '',
        showCaptchaBtn: 1,
      },
      registerForm: {
        reg_email: '',
        login_pwd: '',
        conform_pwd: '',
        captcha_code: '',
        captcha_url: '',
        verify_code: '',
        showCaptchaBtn: 1,
      },
      extraInfoForm: {
        country_name: '中国',
      },
      extraInfoFormVisible: false,
      captcha_id: '',
      tipDialog: false,
    };
  },
  methods: {
    // 关闭注册弹窗
    handleRegisterDialogClose() {
      this.$store.commit('blOpenRegisterBox', false);
      this.registerForm.reg_email = '';
      this.registerForm.login_pwd = '';
      this.registerForm.conform_pwd = '';
      this.registerForm.captcha_code = '';
      this.registerMessageVisible = 'none';
      this.registerForm.showCaptchaBtn = 1;
    },

    // 从登录弹窗跳转到注册弹窗
    toRegisterDialogBox() {
      this.handleLoginDialogClose();
      this.$store.commit('blOpenRegisterBox', true);
    },

    // 关闭注册成功弹窗
    handleRegisterSuccessDialogClose() {
      this.registerSuccessDialogVisible = false;
    },

    // 关闭登录弹窗
    handleLoginDialogClose() {
      this.$store.commit('blOpenLoginBox', false);
      this.loginForm.user_name = '';
      this.loginForm.login_pwd = '';
      this.loginForm.captcha_code = '';
      this.loginForm.showCaptchaBtn = 1;
    },
    // 从注册弹窗跳转到登录弹窗
    toLoginDialogBox() {
      this.handleRegisterDialogClose();
      this.$store.commit('blOpenLoginBox', true);
    },
    // 注册认证码获取
    sendRegCapthaCode() {
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          getRegisterVerifyCode({
            reg_email: this.registerForm.reg_email,
            captcha_id: this.captcha_id,
            captcha_code: this.registerForm.captcha_code,
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data.success === true) {
                  console.log(res.data.data);
                  this.registerMessage = '认证码已发至您的邮箱';
                  this.registerMessageVisible = 'block';
                  this.sendMsgDisabled = true;
                  let codeInterval = window.setInterval(() => {
                    this.codeTime1--;
                    if (this.codeTime1 < 0) {
                      window.clearInterval(codeInterval);
                      this.codeTime1 = 59;
                      this.sendMsgDisabled = false;
                    }
                  }, 1000);
                } else {
                  this.registerMessage = res.data.message;
                  this.registerMessageVisible = 'block';
                }
              } else {
                this.$message.error('未能发送验证码');
                console.log('错误');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    // 注册认证码获取
    sendPhoneRegCapthaCode() {
      this.$refs['extraInfoForm'].validate((valid) => {
        if (valid) {
          let country_code = getCountryCode(this.extraInfoForm.country_name);
          if (country_code === '+86') country_code = '';
          getRegisterPhoneVerifyCode({
            phone: country_code + this.extraInfoForm.phone,
          })
            .then((res) => {
              window.clearInterval(this.codeInterval);
              this.codeTime2 = 59;
              if (res.status === 200) {
                if (res.data.success === true) {
                  console.log(res.data.data);
                  this.registerMessage = '认证码已发至您的手机';
                  this.registerMessageVisible = 'block';
                  this.sendMsgDisabled = true;
                  this.codeInterval = window.setInterval(() => {
                    this.codeTime2--;
                    if (this.codeTime2 < 0) {
                      window.clearInterval(this.codeInterval);
                      this.codeTime2 = 59;
                      this.sendMsgDisabled = false;
                    }
                  }, 1000);
                } else {
                  this.registerMessage = res.data.message;
                  this.registerMessageVisible = 'block';
                }
              } else {
                this.$message.error('未能发送验证码');
                console.log('错误');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    // 注册执行
    handleRegister() {
      if (this.extraInfoFormVisible)
        this.$refs['extraInfoForm'].validate((valid) => {
          if (valid) {
            let country_code = getCountryCode(this.extraInfoForm.country_name);
            if (country_code === '+86') country_code = '';
            register({
              reg_email: this.registerForm.reg_email,
              verify_code: this.registerForm.verify_code,
              login_pwd: this.registerForm.login_pwd,
              phone: country_code + this.extraInfoForm.phone,
              first_name_zh: this.extraInfoForm.first_name_zh,
              last_name_zh: this.extraInfoForm.last_name_zh,
              organization: this.extraInfoForm.organization,
              phone_verify_code: this.extraInfoForm.phone_verify_code,
            })
              .then((res) => {
                if (res.status === 200) {
                  if (res.data.success === true) {
                    this.$message.success(res.data.message);
                    this.handleRegisterDialogClose();
                    this.registerSuccessDialogVisible = true;
                    this.extraInfoFormVisible = false;
                  } else {
                    this.registerMessage = res.data.message;
                    this.registerMessageVisible = 'block';
                  }
                } else {
                  this.$message.error('注册未成功');
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      else
        this.$refs['registerForm'].validate((valid) => {
          if (valid) {
            checkEmail({
              reg_email: this.registerForm.reg_email,
              verify_code: this.registerForm.verify_code,
              login_pwd: this.registerForm.login_pwd,
              captcha_id: this.captcha_id,
              captcha_code: this.registerForm.captcha_code,
            })
              .then((res) => {
                if (res.status === 200) {
                  if (res.data.success === true) {
                    this.$message.success(res.data.message);
                    this.extraInfoFormVisible = true;

                    window.clearInterval(this.codeInterval);
                    this.codeTime = 59;
                    this.sendMsgDisabled = false;
                    this.registerMessageVisible = 'none';
                  } else {
                    this.registerMessage = res.data.message;
                    this.registerMessageVisible = 'block';
                  }
                } else {
                  this.$message.error('注册未成功');
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    regSuccesstoLoginDialogBox() {
      this.handleRegisterSuccessDialogClose();
      this.$store.commit('blOpenLoginBox', true);
    },

    // 登录
    handleLogin() {
      login({
        user_name: this.loginForm.user_name,
        login_pwd: this.loginForm.login_pwd,
        captcha_id: this.captcha_id,
        captcha_code: this.loginForm.captcha_code,
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.success === true) {
              localStorage.eleToken = res.data.data.token;
              this.handleLoginDialogClose();
              this.$store.commit('AddIsLogin', 1);
              this.$store.dispatch('toGetCurrentUser');
              // console.log(localStorage.eleToken)
              // this.$router.go(0);
              // this.$router.push({
              //   path: decodeURIComponent(this.$route.query.redirect),
              // });

              // console.log(this.userForm);
              // if (
              //   this.userForm.name === '' ||
              //   this.userForm.name === null ||
              //   this.userForm.name === undefined
              // ) {
              //   this.tipDialog = true;
              // }
            } else {
              // this.$message.error(res.data.message);
              this.loginMessage = res.data.message;
              this.loginMessageVisible = 'block';
            }
          } else {
            this.$message.error('未请求成功');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleGoUserInfo() {
      this.$router.push({ path: '/myInfo' });
      this.tipDialog = false;
    },

    // 登录框和注册框里的错误返回信息提示
    loginMessageClose() {
      this.loginMessageVisible = 'none';
    },
    registerMessageClose() {
      this.registerMessageVisible = 'none';
    },

    // 从登录弹窗跳转到重置密码
    toResetPassword() {
      this.$router.push('/forgetPassword');
      this.handleLoginDialogClose();
    },
    // 生成验证码随机字符
    randomCaptchaKey() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      this.captcha_id =
        S4() +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        S4() +
        S4();
    },
    // 得到验证码图片
    changeCode() {
      this.randomCaptchaKey();
      getCaptcha({ captcha_id: this.captcha_id })
        .then((res) => {
          if (res.status === 200) {
            let rr = window.URL.createObjectURL(res.data);
            this.loginForm.captcha_url = rr;
            this.registerForm.captcha_url = rr;
          } else {
            this.$message.error('未请求成功');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toGetCaptchaCode() {
      this.changeCode();
      this.loginForm.showCaptchaBtn = 0;
      this.registerForm.showCaptchaBtn = 0;
    },
  },
  mounted() {
    // 得到验证码图片
    // this.toGetCaptchaCode();
  },
  computed: {
    loginDialogVisible: {
      get() {
        return this.$store.state.openLoginBox;
      },
    },
    registerDialogVisible: {
      get() {
        return this.$store.state.openRegisterBox;
      },
    },
    userForm: {
      get() {
        return this.$store.state.toGetCurrentUser.currentUserInfo;
      },
    },
  },
  watch: {
    loginDialogVisible() {
      if (this.loginDialogVisible === true) {
        this.toGetCaptchaCode();
      }
    },
    registerDialogVisible() {
      if (this.registerDialogVisible === true) {
        this.toGetCaptchaCode();
      }
    },
  },
};
</script>

<style scoped></style>
